export default {
    budgets: []
};